export default __webpack_public_path__ + "assets/icon-groups.0262cc35.webp";